export var COLOR;
(function (COLOR) {
    COLOR["MINT"] = "MINT";
    COLOR["ROBIN_EGG_BLUE"] = "ROBIN_EGG_BLUE";
    COLOR["FEDERAL_BLUE"] = "FEDERAL_BLUE";
    COLOR["AUREOLIN"] = "AUREOLIN";
    COLOR["RICH_BLACK"] = "RICH_BLACK";
})(COLOR || (COLOR = {}));
export const COLOR_OPTIONS = {
    [COLOR.MINT]: {
        id: COLOR.MINT,
        hex: '#1AD19E',
        rgb: 'rgb(26, 209, 158)',
        text: 'white'
    },
    [COLOR.ROBIN_EGG_BLUE]: {
        id: COLOR.ROBIN_EGG_BLUE,
        hex: '#00C4C4',
        rgb: 'rgb(0, 196, 196)',
        text: 'white'
    },
    [COLOR.FEDERAL_BLUE]: {
        id: COLOR.FEDERAL_BLUE,
        hex: '#1C1463',
        rgb: 'rgb(28, 20, 99)',
        text: 'white'
    },
    [COLOR.AUREOLIN]: {
        id: COLOR.AUREOLIN,
        hex: '#FCED21',
        rgb: 'rgb(252, 237, 33)',
        text: 'gray'
    },
    [COLOR.RICH_BLACK]: {
        id: COLOR.RICH_BLACK,
        hex: '#000000',
        rgb: 'rgb(0, 0, 0)',
        text: 'white'
    }
};
//# sourceMappingURL=color.js.map